import type { FC, PropsWithChildren } from "react";

import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";

interface ScrollToTopWrapperProps extends PropsWithChildren {
    className?: string;
}

const ScrollToTopWrapper: FC<ScrollToTopWrapperProps> = (props) => {
    const { className = "", children } = props;
    const autoScrollRef = useAutoScrollTop();
    return (
        <div
            className={`sw-layout-scrollable-element use-sticky-css-rendering ${className}`}
            ref={autoScrollRef}
        >
            {children}
        </div>
    );
};

export default ScrollToTopWrapper;
